// Import other element components
import RsvpButtonElement from './elements/RsvpButtonElement';
import RsvpFormElement from './elements/RsvpFormElement';
import TextElement from './elements/TextElement';
import ImageElement from './elements/ImageElement';
import VideoElement from './elements/VideoElement';
import ShapeElement from './elements/ShapeElement';
import BackgroundElement from './elements/BackgroundElement';
import IconElement from './elements/IconElement';

export const ELEMENT_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  VIDEO: 'video',
  SHAPE: 'shape',
  RSVP_BUTTON: 'rsvp-button',
  RSVP_FORM: 'rsvp-form',
  BACKGROUND: 'background',
  ICON: 'icon'
};

// Element registry mapping
export const elementRegistry = {
  [ELEMENT_TYPES.TEXT]: {
    component: TextElement,
    icon: 'text-icon',
    label: 'Text',
    defaultStyles: {
      width: '300px',
      height: 'auto',
      color: '#000000',
      fontSize: '16px',
      fontFamily: 'Arial',
      textAlign: 'left'
    }
  },
  [ELEMENT_TYPES.IMAGE]: {
    component: ImageElement,
    icon: 'image-icon',
    label: 'Image',
    defaultStyles: {
      width: '300px',
      height: '200px',
      objectFit: 'cover'
    }
  },
  [ELEMENT_TYPES.VIDEO]: {
    component: VideoElement,
    icon: 'video-icon',
    label: 'Video',
    defaultStyles: {
      width: '450px',
      height: '253px'
    }
  },
  [ELEMENT_TYPES.SHAPE]: {
    component: ShapeElement,
    icon: 'shape-icon',
    label: 'Shape',
    defaultStyles: {
      width: '100px',
      height: '100px',
      backgroundColor: '#3b82f6',
      shapeType: 'rectangle'
    }
  },
  [ELEMENT_TYPES.RSVP_BUTTON]: {
    component: RsvpButtonElement,
    icon: 'button-icon',
    label: 'RSVP Button',
    defaultStyles: {
      width: '200px',
      height: '50px',
      backgroundColor: '#4caf50',
      textColor: 'white',
      text: 'RSVP Now',
      borderRadius: '4px',
      fontSize: '16px'
    },
    styleOptions: [
      {
        label: 'Background Color',
        property: 'backgroundColor',
        type: 'color'
      },
      {
        label: 'Text Color',
        property: 'textColor',
        type: 'color'
      },
      {
        label: 'Button Text',
        property: 'text',
        type: 'text'
      },
      {
        label: 'Border Radius',
        property: 'borderRadius',
        type: 'text'
      },
      {
        label: 'Font Size',
        property: 'fontSize',
        type: 'text'
      },
      {
        label: 'Width',
        property: 'width',
        type: 'text'
      },
      {
        label: 'Height',
        property: 'height',
        type: 'text'
      }
    ]
  },
  [ELEMENT_TYPES.RSVP_FORM]: {
    component: RsvpFormElement,
    icon: 'form-icon',
    label: 'RSVP Form',
    defaultStyles: {
      width: '400px',
      height: 'auto',
      backgroundColor: '#ffffff',
      borderColor: '#e5e7eb',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
    }
  },
  [ELEMENT_TYPES.BACKGROUND]: {
    component: BackgroundElement,
    icon: 'wallpaper',
    label: 'Background'
  },
  [ELEMENT_TYPES.ICON]: {
    component: IconElement,
    icon: 'icon',
    label: 'Icon',
    defaultStyles: {
      width: '48px',
      height: '48px',
      color: '#333333'
    }
  }
};

// Default export for consistency if needed
export default { ELEMENT_TYPES, elementRegistry };

// Look for code like this - this is likely converting your files to base64
const handleFileChange = (file) => {
  console.log("🔍 FILE SELECTED FOR CONVERSION", {
    name: file.name,
    size: `${(file.size/1024).toFixed(2)} KB`,
    type: file.type
  });
  
  // THIS is likely the culprit - a FileReader that converts to base64
  const reader = new FileReader();
  reader.onload = (e) => {
    console.log("❌ CONVERTING TO BASE64 - THIS SHOULD NOT HAPPEN");
    console.log("❌ Base64 conversion result length:", e.target.result.length);
    // Rest of the code...
  };
  reader.readAsDataURL(file); // This creates a base64 data URL
}; 